import React from "react";
import "./style.css";
import { PageWrapper } from "utility/styled-components";


const PowerBIDashboard: React.FC = () => {

  return (
    // isAdmin ?
    // (
      <PageWrapper>
        <iframe title="Platform Inventory Dashboard" style={{ width: "100%", height: "85vh" }} src="https://app.powerbi.com/reportEmbed?reportId=6d8b62f6-fb31-4869-befc-78e74ce9d730&autoAuth=true&ctid=8c642d1d-d709-47b0-ab10-080af10798fb" frameBorder={0} allowFullScreen={true}></iframe>
      </PageWrapper>
    // )
    // :
    // <Navigate to="/" replace />
  );
};

export default PowerBIDashboard;
